import {download, get, post} from "@/utils/http"

export const _selectPages = params => get("/connersParentScale/selectPages", params);
export const _get = params => get("/connersParentScale/get", params);
export const _save = params => post(params.id ? "/connersParentScale/update" : "/connersParentScale/save", params);
export const _delete = params => get("/connersParentScale/delete", params);
export const _print = params => get("/connersParentScale/print", params);

export const _download = params => get("/connersParentScale/download", params);
export const _export = params => download("/connersParentScale/export", params);



